import React from "react";
import { Fade, Zoom } from "react-reveal";
import { Link } from "react-router-dom";
import FAQImg from "../../Assets/Images/faq.svg";
import "./FAQ.scss";

const FAQ = () => {
  return (
    <>
      <div className="faq-area">
        <div className="container custom-padding-top custom-padding-bottom text-center">
          <Zoom>
            <h1 className="display-3 custom-font text-center">
              Frequently asked questions<span className="dank-red-dot">.</span>
            </h1>
          </Zoom>
          <div className="faq-des d-flex align-items-center justify-content-center">
            <Fade left>
              <div className="faq-image">
                <img src={FAQImg} alt="" className="faq-img mb-5" />
              </div>
            </Fade>
          </div>
          <Fade right>
            <Link to="/allfaqs">
              <button className="btn faq-btn mt-3 py-3 px-5">Go for FAQ</button>
            </Link>
          </Fade>
        </div>
      </div>
    </>
  );
};

export default FAQ;
